import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() variant: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'outline' = 'primary';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() iconPath: string = '';
  @Input() iconPosition: 'left' | 'right' = 'left';
  
  @Output() onClick = new EventEmitter<MouseEvent>();
  
  @HostBinding('class.full-width') get isFullWidth() {
    return this.fullWidth;
  }
  
  get buttonClasses(): string {
    const classes = [
      'app-button',
      `app-button--${this.variant}`,
      `app-button--${this.size}`
    ];
    
    if (this.disabled) {
      classes.push('app-button--disabled');
    }
    
    if (this.loading) {
      classes.push('app-button--loading');
    }
    
    if (this.iconPath && !this.hasContent) {
      classes.push('app-button--icon-only');
    }
    
    return classes.join(' ');
  }
  
  hasContent = true;
  
  ngAfterContentInit() {
    const element = document.querySelector('app-button');
    if (element) {
      this.hasContent = !!element.textContent?.trim();
    }
  }
  
  handleClick(event: MouseEvent): void {
    if (!this.disabled && !this.loading) {
      this.onClick.emit(event);
    }
  }
}